import React from 'react'
import { Button } from './primary'
import { MobileViewportProvider } from '../../utils'

const SaveButton = ({className, mobileClassname, saveText = 'Save', ...props}) => {
  return (
    <div {...props}>
      <Button style={{width: '197px'}} className="hidden md:block lg:block">{saveText}</Button>
      <MobileViewportProvider>
        <Button thin className={`${mobileClassname}`}>{saveText}</Button>
      </MobileViewportProvider>
    </div>
  )
}

export { SaveButton }
